var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);", ""]);
exports.i(require("-!../node_modules/css-loader/index.js?minimize!./btn.css"), "");

// module
exports.push([module.id, "body{font-family:Noto Sans JP,sans-serif!important;background-image:url(" + escape(require("./assets/background.png")) + ");font-size:150%}.row-eq-height{display:flex;flex-wrap:wrap}", ""]);

// exports
